import { EntityId } from "@jackfruit/common"
import { SagaIterator } from "redux-saga"
import { select } from "redux-saga/effects"
import { ImageTransformationEntity } from "~/interfaces/entities/ImageTransformation"
import { imageTransformationsSelectors } from "../state/imageTransformations"
import { RootState } from "../store"

export function* getImageTransformation(
  imageTransformationId: EntityId
): SagaIterator<ImageTransformationEntity> {
  const imageTransformation: ImageTransformationEntity = yield select(
    (state: RootState) =>
      imageTransformationsSelectors.selectById(state, imageTransformationId)
  )

  return imageTransformation
}
